const globals = {
   mode: {
    READ: "read",
    CHOOSE: "choose",
    EDIT: "edit",
    ADD: "add"
  }
}



export default globals;
